import type { Rule } from 'antd/es/form';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useCommunityRules = (): Rule[] => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        validateTrigger: ['onSubmit'],
        // eslint-disable-next-line @typescript-eslint/require-await -- we need return promise with async function
        async validator(_, value) {
          if (!value) {
            throw new Error(t('Please, select a community.'));
          }
        },
      },
    ],
    [t],
  );
};
